var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5102 2.36981L5.19018 9.68981C4.40018 10.1998 3.93018 11.0598 3.93018 11.9998C3.93018 12.9398 4.40018 13.7998 5.19018 14.3098L16.5102 21.6298C17.3702 22.1898 18.4202 22.2298 19.3202 21.7398C20.2202 21.2498 20.7602 20.3498 20.7602 19.3198L20.7602 4.66981C20.7602 3.64981 20.2202 2.73981 19.3202 2.24981C18.4202 1.75981 17.3702 1.79981 16.5102 2.35981L16.5102 2.36981Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.ac6715e9eaa40033201d8d8ba63b6c70.svg";
export { ForwardRef as ReactComponent };